import { TileRoleRoute } from '@/types'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { Roles } from '@/auth/azure/Roles'
import React from 'react'
import { faPeopleRobbery, faTicketSimple } from '@fortawesome/free-solid-svg-icons'

export const RapportoRoute: TileRoleRoute = {
  path: 'rapporti',
  text: 'Rapporti',
  faIcon: faPeopleRobbery,
  element: (
    <ManagementGridFactory
      entity="rapporto"
      referencesCollection={'impiegati'}
      referencesTitle="Rapporti"
      displayField="id"
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Piattaforma Ticket',
      icon: faTicketSimple,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
